import { addCoreSetupAuditTrailViewsSyncSlice } from './add';
import { CoreSetupAuditTrailViewsName } from './name';
import { postSetupAuditTrailViews } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreSetupAuditTrailViewsSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				addCoreSetupAuditTrailViewsSyncSlice.syncActionCreator({
					advanceFilter: request.advanceFilter ?? '',
					filter: request.filter ?? '',
					id: response.viewId,
					name: request.name,
					ordering: request.ordering ?? ''
				})
		]
	},
	name: CoreSetupAuditTrailViewsName,
	receive: true,
	request: true,
	requestHandler: postSetupAuditTrailViews,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Latest
});
